// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"card-image-type-7-m__wrapper__1_PeY"};